import React from "react";
import { Link } from "react-router-dom";
import AllBlogCard from "./AllBlogCard";
import blog from "../../assets/about/blog.jpeg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
const Blog = () => {
  return (
    <div>
      {/* Hero Image */}

      <div
        className="relative text-left py-20 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${blog})` }}
      >
        <div className="absolute inset-0 bg-black opacity-30"></div>
        <div className="flex mx-auto items-start justify-start">
          <div className="relative max-w-3xl px-6 py-2">
            <div className="relative z-10 text-white drop-shadow-xl flex flex-col items-start justify-center h-full">
              <h1 className="md:text-4xl text-2xl font-semibold mb-4">
                Our Blogs{" "}
              </h1>
              <div className="flex items-center space-x-2 text-sm md:text-base">
                <Link
                  to="/"
                  className="text-white hover:text-main1 font-semibold"
                >
                  Home
                </Link>
                <span>
                  <FontAwesomeIcon icon={faChevronRight} className="text-xs" />
                </span>
                <span className="text-gray-300 cursor-pointer hover:text-main1">
                  Blogs
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Breadcrumbs aligned right */}

      {/* Blog Cards */}
      <AllBlogCard />
    </div>
  );
};

export default Blog;
